// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import Address from "./types/address";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class EthereumInitialize extends PerunMessage {
  @jsonMember(Address) clientAddress: Address;
  @jsonMember(Boolean) egoisticClient = true;
  @jsonMember(String) l2Account = "";

  constructor(clientAddress: Address, l2Account?: string) {
    super();
    this.clientAddress = clientAddress;
    if (l2Account) {
      this.l2Account = l2Account;
    }
  }

  messageType(): MessageType {
    return EthereumInitialize;
  }

  messageTypeName(): MessageTypeName {
    return "EthereumInitialize";
  }
}
